import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '夜间生活', href: '/category/night-life' },
    { label: '创作灵感', href: '/category/creative-inspiration' },
    { label: '深夜情绪', href: '/category/late-night-emotion' },
    { label: '夜行者社群', href: '/category/night-walker-community' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌故事', href: '/about' },
    { label: '加入社群', href: '/about' },
    { label: '联系我们', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20">
                <i className="ri-moon-clear-line text-primary-400 text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-100">夜无疆</span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              打破黑夜边界的极致体验。关于夜晚无限可能的探索平台，陪你穿越每一个漫长黑夜。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-all duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-all duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-all duration-200 cursor-pointer" aria-label="小红书" rel="nofollow">
                <i className="ri-chat-smile-2-line"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-foreground-200 text-base mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-heading text-foreground-200 text-base mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-heading text-foreground-200 text-base mb-4">夜无疆通讯</h4>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              每周精选夜间故事、创作灵感和社群活动，直接发送到你的邮箱。
            </p>
            <form
              data-readdy-form
              id="footer-newsletter"
              action="https://readdy.ai/api/form/d9u074n8l97n3eas3erg"
              method="POST"
              className="flex flex-col sm:flex-row gap-2"
            >
              <div className="website-field-wrap">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                placeholder="输入你的邮箱"
                required
                className="flex-1 px-4 py-2.5 bg-background-800 border border-background-700 rounded-lg text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-all duration-200"
              />
              <button
                type="submit"
                className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-800/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 夜无疆. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors duration-200">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}